import { type ViewSurface } from '@terros/common'

export type ViewOrderPreference = 'accountListViewOrder' | 'areaManagementViewOrder'

export function getViewOrderPreference(surface: ViewSurface): ViewOrderPreference {
  return surface === 'accountList' ? 'accountListViewOrder' : 'areaManagementViewOrder'
}
